__turbopack_context__.v({
  "avatarOnRing": "AvatarSpeechBubble-module__WN4zGa__avatarOnRing",
  "background__coral": "AvatarSpeechBubble-module__WN4zGa__background__coral",
  "bubble": "AvatarSpeechBubble-module__WN4zGa__bubble",
  "closeButton": "AvatarSpeechBubble-module__WN4zGa__closeButton",
  "container": "AvatarSpeechBubble-module__WN4zGa__container",
  "tail": "AvatarSpeechBubble-module__WN4zGa__tail",
  "tail__left-corner": "AvatarSpeechBubble-module__WN4zGa__tail__left-corner",
  "tail__left-side": "AvatarSpeechBubble-module__WN4zGa__tail__left-side",
});
